import { render, staticRenderFns } from "./SignButton.vue?vue&type=template&id=c371345e&scoped=true&"
import script from "./SignButton.vue?vue&type=script&lang=js&"
export * from "./SignButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c371345e",
  null
  
)

export default component.exports